import type { Chord } from 'svguitar';
import { cn } from '@/lib/utils';
import { ChordDiagram } from './chord-diagram';

const AMBER = 'var(--section-pre-refrao)';

/** Card de acorde com diagrama; sem forma cadastrada vira card tracejado âmbar. */
export const ChordCard: React.FC<{
  name: string;
  shape?: Chord;
  /** Para fundo branco (impressão). */
  onLight?: boolean;
  className?: string;
}> = ({ name, shape, onLight, className }) =>
  shape ? (
    <div
      className={cn(
        'flex flex-col items-center gap-1 rounded-[10px] border p-2',
        onLight ? 'border-black/20 bg-white' : 'border-border bg-raised',
        className,
      )}
    >
      <ChordDiagram shape={shape} onLight={onLight} />
      <span
        className={cn('font-bold text-[12px]', onLight ? 'text-black' : 'text-white')}
      >
        {name}
      </span>
    </div>
  ) : (
    <div
      className={cn(
        'flex h-[110px] flex-col items-center justify-center gap-1 rounded-[10px] border border-dashed p-2 text-center',
        className,
      )}
      style={{ borderColor: AMBER, color: AMBER }}
    >
      <span className="font-bold text-[13px]">{name}</span>
      <span className="text-[10.5px] uppercase tracking-wider">sem forma</span>
    </div>
  );

/** Chip de acorde detectado: azul com diagrama, âmbar tracejado sem. */
export const ChordChip: React.FC<{ name: string; hasShape: boolean }> = ({
  name,
  hasShape,
}) => (
  <span
    className={cn(
      'inline-flex h-7 items-center rounded-full border px-2.5 font-bold text-[12px]',
      hasShape
        ? 'border-accent-line bg-accent-surface text-accent-soft'
        : 'border-dashed bg-transparent',
    )}
    style={hasShape ? undefined : { borderColor: AMBER, color: AMBER }}
    title={hasShape ? 'Tem diagrama' : 'Sem diagrama cadastrado'}
  >
    {name}
  </span>
);
